export default __webpack_public_path__ + "static/media/half-right-arrow-blue.d6038228.svg";